import {styled} from '@mui/material/styles';
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import {Button, FormControlLabel, Radio, RadioGroup, TextField} from "@mui/material";
import {Link} from 'react-router-dom';
import List from "@mui/material/List";
import {TextareaAutosize} from "@mui/material";
import Tabs from "@mui/material/Tabs";
import { CheckBox } from '@mui/icons-material';

export const ContainerBox = styled(Stack)(({
                                               theme,
                                               height,
                                               width,
                                               padding,
                                               bgColor,
                                               mb,
                                               ml,
                                               mr,
                                               workInformationFormHide
                                           }) => ({
    backgroundColor: bgColor ?? theme.palette.background.default,
    padding: padding ?? 'unset',
    borderRadius: 12,
    margin: '0 16px 16px 16px',
    fontSize: 14,
    flex: "auto",
    minHeight: height,
    width: width ?? "auto",
    flexWrap: "wrap",
    [theme.breakpoints.up("sm")]: {
        margin: `0 ${mr ?? 0}px ${mb ?? '16'}px ${ml ?? '16'}px`,
    },

    [theme.breakpoints.up("md")]: {
        margin: `0 ${mr}px ${mb ?? '16'}px ${ml ?? '16'}px`,
    },
    //enable disable work_information
    opacity: workInformationFormHide ? 0.4 : 1,
    cursor: workInformationFormHide ? "not-allowed" : "",
}));

export const ContainerFacilitySelectBox = styled(Stack)(({theme, height, padding, bgColor}) => ({
    backgroundColor: bgColor ?? theme.palette.background.default,
    padding: padding ?? 'unset',
    borderRadius: 12,
    fontSize: 14,
    flex: "auto",
    minHeight: height,
    flexWrap: "wrap",
    [theme.breakpoints.up("sm")]: {
        // width: "100%"
    },
}));

export const HeaderStack = styled(Stack)(({theme}) => ({
    backgroundColor: theme.palette.background.default,
    paddingLeft: 20,
    paddingRight: 10,
    borderRadius: 12,
    margin: 16,
    height: 72,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',

    [theme.breakpoints.up("sm")]: {
        margin: "48px 50px 16px 50px",
    }, [theme.breakpoints.up("md")]: {
        margin: "48px 120px 16px 120px",
    }
}));

export const PageHeaderTitleBox = styled(Stack)(({theme}) => ({
    paddingRight: 10,
    [theme.breakpoints.up("xs")]: {
        fontSize: 16,
    },
    [theme.breakpoints.up("sm")]: {
        fontSize: 18,
    }
}));

export const PageHeaderIconBox = styled(Box)(({theme}) => ({
    backgroundColor: theme.palette.background.second,
    borderRadius: '50%',
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& .MuiSvgIcon-root': {
        fontSize: 18,
    }
}));

export const ButtonStyled = styled(Button)(({theme, width, height, gap, minWidth, hide}) => ({
    width: width ?? minWidth,
    height: height,
    display: hide ? 'none' : 'flex',
    justifyContent: 'center',
    gap: gap ?? 8,
    fontSize: 14,
    fontWeight: "bold",
    alignItems: 'center',
    borderRadius: 12,
    boxShadow: 'unset!important',

    [theme.breakpoints.up("sm")]: {
        minWidth: minWidth ?? 170,
        height: 50,
        fontSize: 14
    },
    [theme.breakpoints.down("sm")]: {
        minWidth: minWidth ?? 100,
    },
    '& .MuiButton-endIcon': {
        marginLeft: "-8px!important"
    },
    '& .MuiButton-startIcon': {
        marginRight: "0!important"
    }
}));

export const LinkStyled = styled(Link)(({theme}) => ({
    textDecoration: 'none'
}));

export const AnchorStyled = styled('a')(({theme,color}) => ({
    textDecoration: 'none',
    color: color ? theme.palette.primary.main : theme.palette.info.main,
    borderBottom: `1px solid ${color ? theme.palette.primary.main : theme.palette.info.main}`,
}));

export const FixedBox = styled(Stack)(({theme}) => ({
    backgroundColor: theme.palette.background.default,
    height: 172,
    width: '100%',
    position: 'fixed',
    bottom: 0,
    borderRadius: '24px 24px 0 0',
    padding: 24,
    flexDirection: 'column',
    alignItems: 'center',
    gap: 24,
    boxShadow: '0px -4px 10px rgba(105, 104, 104, 0.06)'
}));

export const HrLine = styled(Box)(({theme}) => ({
    backgroundColor: theme.palette.text.primary,
    width: '100%',
    height: 1
}));

export const ListStyled = styled(List)(({theme, workInformationFormHide}) => ({
    backgroundColor: theme.palette.background.default,
    width: '100%',
    borderRadius: 16,
    pointerEvents: workInformationFormHide ? "none" : "auto",
    paddingBottom: 10,
}));

export const LabelStyled = styled('label')(({theme, padding}) => ({
    color: theme.palette.text.main,
    fontSize: 14,
    display: 'inline-block',
    padding: padding ?? undefined,
}));

export const TextFieldStyled = styled(TextField)(({theme, width, height}) => ({
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.main,
    boxShadow: 'unset!important',
    fontSize: 14,
    height: height ?? 48,
    width: width ?? 200,
    '& .MuiInputBase-root': {
        borderRadius: 12,
    },

    '& .MuiSvgIcon-root': {
        fontSize: 24
    },
    "& .MuiOutlinedInput-notchedOutline": {
        border: `1px solid #D9E2E7`,
    },
    "input": {
        height: height ?? 12,
        color: theme.palette.tertiary.main,
        fontSize: 14,
    },
    "& .MuiFormHelperText-root": {
        textAlign: "right",
        marginRight: "5px!important"
    },
    '& .Mui-focused fieldset': {
        border: '1px solid #808080'
    },

    [theme.breakpoints.up("xs")]: {
        minWidth: width ?? 200,
        width: width ? 82 : 290,
    },

    [theme.breakpoints.up("sm")]: {
        width: width ?? 220,
        height: 48
    },

}));

export const TextareaAutosizeStyled = styled(TextareaAutosize)(({theme, width, inputError}) => ({
    backgroundColor: theme.palette.background.default,
    borderRadius: 12,
    width: width ?? "98%",
    border: `1px solid ${inputError ? theme.palette.error.main : "#D9E2E7"}`,
    outline: "none",
    direction: "rtl",
    padding: 10,
    marginTop: 8,
    resize: "none",
    height: 50,
    boxShadow: 'unset!important',
    '&:focus': {
        border: `1px solid ${inputError ? theme.palette.error.main : "#D9E2E7"}`,
    },
    [theme.breakpoints.up("sm")]: {
        width: width ?? "100%",
    },
}));
export const Separator = styled(Box)(({theme}) => ({
    fontSize: 18,
    color: theme.palette.text.primary,
}));

export const BoxInfo = styled(Stack)(({theme, width}) => ({
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.main,
    width: width,
    height: 50,
    flexWrap: "wrap",
    [theme.breakpoints.up("sm")]: {
        height: 50,
    },
    [theme.breakpoints.up("md")]: {
        height: 64,
    },
    border: '1px solid #D9E2E7',
    borderRadius: 12,
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 14,
    overflow: "hidden",
    position: "relative"
}));

export const DocumentGridList = styled('ul')(({
    theme,
    paddingRight,
}) => ({
    display: 'grid',
    fontSize: 14,
    gridTemplateColumns: "repeat(2,minmax(0,1fr))",
    gap: 20,
    paddingTop: 20,
    paddingRight: paddingRight ?? 25,
    [theme.breakpoints.up("sm")]: {
        paddingRight: paddingRight ?? 30,
    },
    [theme.breakpoints.down("sm")]: {
        gridTemplateColumns: "repeat(1,minmax(0,1fr))",
    },
}));
export const DocumentList = styled('ul')(({
                                              theme,
                                              paddingTop,
                                              paddingBottom,
                                              paddingRight,
                                              alignItems,
                                              gap,
                                              textAlign
                                          }) => ({
    display: 'flex',
    fontSize: 14,
    flexDirection: "column",
    alignItems: alignItems ?? "flex-start",
    gap: gap ?? 20,
    paddingTop: paddingTop ?? 20,
    paddingBottom: paddingBottom ?? 20,
    paddingRight: paddingRight ?? 25,
    paddingLeft: 0,
    textAlign: textAlign ?? "unset",
    height: 'fit-content',
    [theme.breakpoints.up("sm")]: {
        paddingRight: paddingRight ?? 30,
    },
}));
export const DocumentListItem = styled('li')(({theme}) => ({
    color: theme.palette.text.main,
    listStyleType: "none",
    display: 'flex',
    flexDirection: "row",
    alignItems: "baseline",
    gap: 10,
    paddingLeft: 14,
}));

export const HrefLinkStyled = styled(Link)(({theme, fontSize}) => ({
    color: theme.palette.info.main,
    textDecoration: "none",
    borderBottom: `1px solid ${theme.palette.info.main}`,
    fontSize: fontSize ?? 14
}));

export const OnlineRegistrationBox = styled(Stack)(({theme}) => ({
    borderRadius: 12,
    border: '1px solid #FD6A16',
    width: '90%',
    height: 'fit-content',
    margin: "20px auto",
    display: "flex",
    padding: 14,
    gap: 8,
    flexDirection: 'column',
    overflow: "auto",
}));

export const DividerStyled = styled(Box)(({theme}) => ({
    backgroundColor: theme.palette.primary.main,
    width: 54,
    height: 3,
    [theme.breakpoints.up("sm")]: {
        width: 65
    },
}));

export const VerticalDividerStyled = styled(Box)(({theme, height}) => ({
    backgroundColor: theme.palette.text.primary,
    width: 1,
    height: height ?? 30,
    marginRight: 4
}));

export const LiStyled = styled(`li`)(({theme}) => ({
    width: "100%",
    height: "100%",
    fontSize: 14,
    color: theme.palette.text.main,

    '@media(min-width:200px) and (max-width:600px)': {
        width: "fit-content",
        height: "fit-content",
    },
}))

export const UploadFileBox = styled(Stack)(({theme, pendingStyle, disabledEvents}) => ({
    backgroundColor: theme.palette.background.default,
    // border: borderPendingStyle ? "1px dashed #FD6A16" : "1px solid #D9E2E7",
    border: !pendingStyle && "1px solid #D9E2E7",
    backgroundImage: pendingStyle &&
        `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='12' ry='12' stroke='%23FD6A16FF' stroke-width='2' stroke-dasharray='4%2c 8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,
    borderRadius: 12,
    flexDirection: "row",
    width: "100%",
    flex: "auto",
    height: 'auto',
    cursor: disabledEvents ? "not-allowed" : "pointer",
    justifyContent: "space-between",
    position: "relative",
    [theme.breakpoints.up("sm")]: {
        width: "45%",
    },
}));

export const GridBox = styled(Stack)(({theme,showBorder}) => ({
   width: '100%',
   height: '26%',
   display:"flex",
   flexDirection:"row",
   gap: 12,
   paddingTop: 20,
   overflow: "auto hidden",
   scrollSnapType: "x mandatory",
   cursor: "e-resize",
   borderTop: showBorder && "1px solid #D9E2E7",
}));

export const UploadFileEachDoc = styled(Stack)(({theme, pendingStyle,disabledEvents,selectedDocStyle}) => ({
    backgroundColor: theme.palette.background.default,
    // border: borderPendingStyle ? "1px dashed #FD6A16" : "1px solid #D9E2E7",
    border: (selectedDocStyle ? "2px solid #fd6a16" : (!pendingStyle && "2px solid #D9E2E7")),
    backgroundImage: (!selectedDocStyle && (pendingStyle &&
        `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='12' ry='12' stroke='%23FD6A16FF' stroke-width='2' stroke-dasharray='4%2c 8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`)),
    borderRadius: 12,
    display: "flex",
    alignItems: "center",
    scrollSnapAlign: "start",
    width: 104,
    height: 104,
    position:"relative",
    cursor: disabledEvents ? "not-allowed" : "pointer",
}));

export const CanvasStyled = styled('canvas')(({theme}) => ({
    backgroundColor: theme.palette.background.default,
    width: 300,
    height: 150,
}));

export const DeliveryTab = styled(Stack)(({theme}) => ({
    backgroundColor: theme.palette.background.default,
    borderRadius: 12,
    margin: 16,
    height: 75,
    position: "relative",
    overflow: "hidden",

    [theme.breakpoints.up("sm")]: {
        margin: "0 50px 16px 50px",
    }, [theme.breakpoints.up("md")]: {
        margin: "0 120px 16px 120px",
    }
}));

export const TabsStyled = styled(Tabs)(({theme}) => ({
    width: "100%",
    height: "100%",

    "& .MuiTabs-flexContainer": {
        justifyContent: "space-around",
        width: "100%",
        height: "100%",
    },
    "& .MuiTab-textColorPrimary": {
        color: theme.palette.tertiary.main,
    },
    "& .Mui-selected": {
        color: theme.palette.primary.main,
        fontWeight: "bold"
    },
    "& .MuiTabs-indicator": {
        height: 3,
        [theme.breakpoints.up("sm")]: {
            height: 4,
        }
    }
}))

export const TabComponentStyled = styled(Stack)(({theme}) => ({
    backgroundColor: theme.palette.background.default,
    borderRadius: 12,
    height: "fit-content",

    [theme.breakpoints.up("sm")]: {
        margin: "0 20px 0 20px",
    }
}))

export const InfoBoxStyled = styled(Stack)(({theme}) => ({
    backgroundColor: "rgba(41,129,236,0.1)",
    color: "#2981EC",
    borderRadius: 12,
    height: 74,
    padding: 10,
    flexDirection: "row",
    alignItems: "start",
    gap: 2,
    marginTop: 8,
    [theme.breakpoints.up("sm")]: {
        height: "fit-content",
        padding: "14px 8px"
    }
}))

export const RadioGroupStyled = styled(RadioGroup)(({theme}) => ({
    gap: 12,
}))

export const FormControlLabelStyled = styled(FormControlLabel)(({theme}) => ({
    gap: 4,
    marginRight: -5,
    color: theme.palette.tertiary.main,

    "& .MuiFormControlLabel-label": {
        fontSize: 14
    }
}))

export const RadioButtonStyled = styled(Radio)(({theme}) => ({
    color: theme.palette.text.primary,
    '& .MuiSvgIcon-root': {
        fontSize: 24,
    }
}))

export const CropBox = styled(Stack)(({theme,borderStyle}) => ({
    position:"relative",
    border: `2px ${borderStyle ? 'solid' : 'dashed'} #D9E2E7`,
    borderRadius: 12,
    justifyContent: "center",
    alignItems: "center",
    gap: 40,
    marginTop: 12,
    width: "calc(100% - 90px)",
    maxWidth: "calc(100% - 90px)",
    minHeight: 300,
    [theme.breakpoints.down("sm")]: {
        minWidth: "calc(100% - 10px)",
        minHeight: 300,
        // maxHeight: "calc(100% + 50px)",
    }
}))

export const InputUploadMoreFileBox = styled(`label`)(({theme, show}) => ({
    color: show ? theme.palette.primary.main : '#fff',
    backgroundColor: show ? theme.palette.secondary.main : theme.palette.primary.main,
    borderRadius: 12,
    width: "100%",
    textAlign: "center",
    whiteSpace: "nowrap",
    height: 50,
    fontSize: 14,
    padding: "8px 16px",
    fontWeight: "bold",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 8,
    userSelect:"none",
    "&:hover": {
        backgroundColor: show ? 'rgba(240,94,14,0.19)' : 'rgba(193,70,0)',
        transition: "backgroundColor 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
}))

export const InputUploadBox = styled(`label`)(({theme, show}) => ({
    color: show ? theme.palette.secondary.main : theme.palette.info.main,
    borderRadius: 12,
    width: "100%",
    textAlign: "center",
    whiteSpace: "nowrap",
    height: 50,
    fontSize: 14,
    fontWeight: "500",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 8,
    userSelect:"none",
    cursor: "pointer",
    "&:hover": {
        color: show ? 'rgba(41, 129, 236, 0)' : '#006aeb',
        transition: "all 0.2s ease-in-out",
    },
}))

export const DeleteDocBox = styled(Stack)(({theme, show}) => ({
    backgroundColor: theme.palette.text.main,
    justifyContent:"center",
    alignItems:"center",
    borderRadius: "50%",
    width: 32,
    height: 32,
    position: "absolute",
    zIndex: 1,
    left: 12,
    top: 12

}))
